import { Api } from "@/models/class/api.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { Pagination } from "@/models/constant/interface/common.interface";
import { ErrorResponseModel } from "@/models/interface/http.interface";
import { InternalContractListDto } from "@/models/interface/internal-contract";
import { FileCreateResponseDto } from "@/models/interface/storage";
import { AxiosError } from "axios";
import { HttpClient } from "./HttpClient.service";

class ContractUploaderService extends HttpClient {
  list(params?: RequestQueryParams) {
    return this.get<Pagination<InternalContractListDto>>(Api.InternalContract, {
      params,
    })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  uploadToMinio(formData: FormData) {
    return this.post<FileCreateResponseDto, FormData>(
      `${Api.uploadFileModul}/internal-contract`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    )
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  updateFileContract(icId: string, fileContract: string) {
    return this.put<string, { fileContract: string }>(
      `${Api.UploaderInternalContract}/${icId}`,
      { fileContract }
    )
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }

  getFile(filePath: string) {
    return this.get<Blob>(`${Api.uploadFileModul}/${filePath}`, {
      responseType: "blob",
    })
      .then(this.success)
      .catch((error: AxiosError<ErrorResponseModel>) => {
        throw this.error(error);
      });
  }
}

const contractUploaderService = new ContractUploaderService();

export { contractUploaderService };
